import { useMemo } from "react";
import { useSubscriptionInfo } from "./useSubscriptionInfo";
import { useUsageLimits } from "./useUsageLimits";

export function useUsageMessage() {
  const { subscriptionTier, usingPrompts } = useSubscriptionInfo();
  const { remainingUsage } = useUsageLimits();

  const usageMessage = useMemo(() => {
    if (Object.keys(remainingUsage).length === 0) return "";

    if (remainingUsage.hasPromptsLeft === false) {
      return "No prompts available.";
    }

    // new plans
    if (usingPrompts) {
      const combinedPrompts =
        Math.min(
          remainingUsage.dailyPromptsLeft === undefined
            ? Number.POSITIVE_INFINITY
            : remainingUsage.dailyPromptsLeft,
          remainingUsage.monthlyPromptsLeft === undefined
            ? Number.POSITIVE_INFINITY
            : remainingUsage.monthlyPromptsLeft
        ) + (remainingUsage.extraPromptsInPackages || 0);

      // If there are more than 10 prompts in packages, don't show anything
      if (combinedPrompts > 10) {
        return "";
      }

      // If there are prompts in packages
      if (
        remainingUsage.extraPromptsInPackages !== undefined &&
        remainingUsage.extraPromptsInPackages > 0
      ) {
        return `${combinedPrompts} combined prompt(s) left`;
      }

      // If there are no prompt packages, show the lower of daily or monthly prompts
      const dailyPromptsLeft = remainingUsage.dailyPromptsLeft;
      const monthlyPromptsLeft = remainingUsage.monthlyPromptsLeft;

      if (dailyPromptsLeft !== undefined && monthlyPromptsLeft !== undefined) {
        if (monthlyPromptsLeft <= dailyPromptsLeft) {
          return `${monthlyPromptsLeft} prompts left this month`;
        }
        return `${dailyPromptsLeft} prompts left today`;
      }
      if (monthlyPromptsLeft !== undefined) {
        return `${monthlyPromptsLeft} prompts left this month`;
      }
    } else {
      // old plan
      if (
        remainingUsage.tokensLeft !== undefined &&
        remainingUsage.tokensLeft < 500000
      ) {
        return `${Math.floor(remainingUsage.tokensLeft / 1000)}k tokens left`;
      }
    }

    return "";
  }, [remainingUsage, subscriptionTier]);

  return {
    usageMessage,
  };
}
